import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import { toast } from "react-toastify";
import { IoIosArrowBack } from "react-icons/io";

import axios from "axios";
import { GetRamaLogs, UseCaseeventListApi } from "../../../api/api";
import EventLineDrawer from "../../../Components/popup/DrawEvent";

function Setlinetrack() {
  const dispatch = useDispatch();
  const id = useParams();
  const [drawingEnabled, setDrawingEnabled] = useState(false);
  const [drawMode, setDrawMode] = useState("line");
  const [isDrawing, setIsDrawing] = useState(false);
  const [lines, setLines] = useState([]);
  const [currentLine, setCurrentLine] = useState([]);
  const [lastLine, setLastLine] = useState(null);
  const [draggingPointIndex, setDraggingPointIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [useCase, setUseCase] = useState([]);
  const [lineOrientation, setLineOrientation] = useState(null);
  const [showDirectionSelect, setShowDirectionSelect] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [inputData, setInputData] = useState({ use_case: "" });
  const [restrictedSide, setRestrictedSide] = useState("");
  const [name, setName] = useState("");
  const imageRef = useRef(null);
  const canvasRef = useRef(null);
  const audioRef = useRef(null);

  const getCanvasPos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    return {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };
  };

  const fetchUseCase = async () => {
    try {
      const data = await UseCaseeventListApi();
      if (data?.data?.status === true) {
        setUseCase(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  useEffect(() => {
    fetchUseCase();
  }, []);

  const handleDrawClick = () => {
    setDrawingEnabled(true);
    setLines([]);
    setCurrentLine([]);
  };

  const handleMouseDown = (e) => {
    const pos = getCanvasPos(e);
    if (!drawingEnabled) return;

    if (drawMode === "line" && lines.length > 0) {
      const line = lines[0];
      const [start, end] = line.points;
      const distance = (a, b) => Math.sqrt((a.x - b.x) ** 2 + (a.y - b.y) ** 2);
      const threshold = 10;

      if (distance(pos, start) < threshold) {
        setDraggingPointIndex(0);
        return;
      } else if (distance(pos, end) < threshold) {
        setDraggingPointIndex(1);
        return;
      }
    }

    if (drawMode === "line") {
      setIsDrawing(true);
      setCurrentLine([pos]);
    } else {
      setCurrentLine((prev) => [...prev, pos]);
    }
  };

  const handleMouseMove = (e) => {
    const pos = getCanvasPos(e);

    if (draggingPointIndex !== null && lines.length > 0) {
      const updatedLines = [...lines];
      const updatedPoints = [...updatedLines[0].points];
      updatedPoints[draggingPointIndex] = pos;
      updatedLines[0].points = updatedPoints;
      setLines(updatedLines);
      const [start, end] = updatedPoints;
      setLastLine({ x1: start.x, y1: start.y, x2: end.x, y2: end.y });
      return;
    }

    if (!isDrawing || drawMode !== "line" || !drawingEnabled) return;
    setCurrentLine((prev) => [...prev, getCanvasPos(e)]);
  };

  const handleMouseUp = () => {
    if (draggingPointIndex !== null) {
      setDraggingPointIndex(null);
      return;
    }

    if (!drawingEnabled) return;

    if (drawMode === "line" && currentLine.length > 1) {
      const start = currentLine[0];
      const end = currentLine[currentLine.length - 1];
      const dx = Math.abs(end.x - start.x);
      const dy = Math.abs(end.y - start.y);
      const THRESHOLD = 10;
      let orientation = dx > dy ? "horizontal" : "vertical";
      if (dx < THRESHOLD && dy >= THRESHOLD) orientation = "vertical";
      if (dy < THRESHOLD && dx >= THRESHOLD) orientation = "horizontal";

      const lineData = {
        points: [start, end],
        orientation: "inside",
        direction: "left",
      };

      setLines([lineData]);
      setLastLine({ x1: start.x, y1: start.y, x2: end.x, y2: end.y });
      setLineOrientation(orientation);
      setShowDirectionSelect(true);
      setCurrentLine([]);
    }

    setIsDrawing(false);
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.lineWidth = 2;
    ctx.strokeStyle = "#00AEEF";

    lines.forEach((line) => {
      const points = line.points;
      if (!points || points.length < 2) return;

      ctx.beginPath();
      ctx.moveTo(points[0].x, points[0].y);
      points.forEach((p, i) => {
        if (i > 0) ctx.lineTo(p.x, p.y);
      });

      if (drawMode === "polygon") ctx.closePath();
      ctx.stroke();

      points.forEach((pt) => {
        ctx.beginPath();
        ctx.arc(pt.x, pt.y, 4, 0, 2 * Math.PI);
        ctx.fillStyle = "blue";
        ctx.fill();
      });

      if (drawMode === "line") {
        const [start, end] = points;
        const midX = (start.x + end.x) / 2;
        const midY = (start.y + end.y) / 2;
        const angle = Math.atan2(end.y - start.y, end.x - start.x);
        const offset = 12;
        const offsetX = offset * Math.cos(angle + Math.PI / 2);
        const offsetY = offset * Math.sin(angle + Math.PI / 2);

        const drawTriangle = (x, y, angle, color) => {
          ctx.save();
          ctx.translate(x, y);
          ctx.rotate(angle);
          ctx.beginPath();
          ctx.moveTo(0, -10);
          ctx.lineTo(-5, 5);
          ctx.lineTo(5, 5);
          ctx.closePath();
          ctx.fillStyle = color;
          ctx.fill();
          ctx.restore();
        };

        drawTriangle(midX + offsetX, midY + offsetY, angle + Math.PI, "red");
        drawTriangle(midX - offsetX, midY - offsetY, angle, "green");
      }
    });

    if (currentLine.length > 0) {
      ctx.beginPath();
      currentLine.forEach((point, index) => {
        index === 0
          ? ctx.moveTo(point.x, point.y)
          : ctx.lineTo(point.x, point.y);
      });
      ctx.stroke();
    }
  }, [lines, currentLine]);

  const handleSubmit = async () => {
    if (!lines.length) return toast.warn("No shape drawn!");

    setLoading(true);

    try {
      const shape = lines[lines.length - 1];
      const coordinates = shape.points.map((point) => [
        Math.round(point.x),
        Math.round(point.y),
      ]);
      const [start, end] = shape.points;
      const payload = {
        camera_id: id?.id,
        line_start: [Math.round(start.x), Math.round(start.y)],
        line_end: [Math.round(end.x), Math.round(end.y)],
        shape_type: drawMode,
        action_type_ids: [],
        alert_type_ids: [],
        usecase_id: inputData.use_case,
        restricted_type: restrictedSide,
        event_name: name,
      };

      const response = await axios.post(
        "https://visionemptrack.greymatterz.com/person_count/set_line",
        payload
      );
      //   setEventRecord(payload);
      if (response?.data?.status) {
        toast.success("Event saved successfully!");
        fetchRecord();
      } else toast.error("Something went wrong!");
    } catch (err) {
      toast.error("Error saving event!");
    } finally {
      setLoading(false);
    }
  };

  const fetchRecord = async () => {
    try {
      const records = await GetRamaLogs();
      //console.log("records", records);
    } catch (error) {
      //console.log("error", error);
    }
  };

  useEffect(() => {
    fetchRecord();
  }, []);
  return (
    <div>
      <div className="entranceGroup">
        <IoIosArrowBack size={22} /> Camera / Entrance Group
      </div>
      <div className="container mt-5">
        <div className="image-area-wrapper">
          <div
            className="image-container"
            ref={imageRef}
            style={{ position: "relative", width: "960px", height: "540px" }}
          >
            <img
              src={
                "https://visionemptrack.greymatterz.com/person_count/video_feed"
              }
              alt="Camera Feed"
              className="camera-image"
            />
            {drawingEnabled && (
              <canvas
                ref={canvasRef}
                width={960}
                height={540}
                style={{ position: "absolute", top: 0, left: 0 }}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
              />
            )}
          </div>

          <audio ref={audioRef} src="/alert.mp3" preload="auto" />

          <div className="button-group">
            {/* {drawingEnabled && (
              <select
                value={drawMode}
                onChange={(e) => setDrawMode(e.target.value)}
                style={{ padding: "4px", marginRight: "8px" }}
              >
                <option value="line">Line</option>
                <option value="polygon">Polygon</option>
              </select>
            )} */}

            <button className="action-btn" onClick={() => setShowDrawer(true)}>
              Add Event
            </button>
            {/* <button onClick={handleStop}>Stop</button> */}

            {/* {drawMode === "polygon" && currentLine.length >= 3 && (
              <button className="action-btn" onClick={handleCompletePolygon}>
                Complete Polygon
              </button>
            )} */}
          </div>
        </div>

        {showDrawer && (
          <EventLineDrawer
            isName={true}
            onClose={() => setShowDrawer(false)}
            onSubmit={(data) => {
              //console.log("Event Data Submitted:", data);
              handleSubmit();
              setShowDrawer(false);
            }}
            handleDrawClick={(mode) => {
              setDrawMode(mode);
              handleDrawClick();
            }}
            useCaseId={inputData.use_case}
            setUseCaseId={(value) =>
              setInputData((prev) => ({ ...prev, use_case: value }))
            }
            restrictedSide={restrictedSide}
            setRestrictedSide={setRestrictedSide}
            useCaseList={useCase}
            lineOrientation={lineOrientation}
            showDirectionSelect={showDirectionSelect}
            setShowDirectionSelect={setShowDirectionSelect}
            setName={setName}
            name={name}
            drawMode={drawMode}
            currentLine={currentLine}
          />
        )}
      </div>
    </div>
  );
}

export default Setlinetrack;
